module.exports = __webpack_public_path__ + "img/help6.e5ad76b3.png";